import { render } from "./category-name.vue?vue&type=template&id=243a9ad3&ts=true"
import script from "./category-name.vue?vue&type=script&lang=ts"
export * from "./category-name.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__